import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TestSnippetStatus as TestSnippetStatusMutation,
    TestSnippetStatusVariables as TestSnippetStatusVariables,
    SnippetStatusTestInput,
} from 'nutshell-graphql-types';

import TEST_SNIPPET_STATUS from '../mutations/test-snippet-status.graphql';

export const useTestSnippetStatus = (): {
    testSnippetStatus: (arg1: SnippetStatusTestInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [testSnippetStatus, {loading, error}] = useMutation<
        TestSnippetStatusMutation,
        TestSnippetStatusVariables
    >(TEST_SNIPPET_STATUS);

    return {
        testSnippetStatus: (input: SnippetStatusTestInput) =>
            testSnippetStatus({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
